



































import { Component, Vue } from "vue-property-decorator";
import moduleHeader from "@/components/moduleHeader/index.vue";
import { fetchExportStatus } from "@/api/download";
import { fetchUserDetail } from "@/api/users";
import { downLoadPdf, testPdf } from "@/api/print";
import { CommonMudule } from "@/store/modules/common";
import { cloneDeep } from "lodash";
import { UserModule } from "@/store/modules/user";
import { stringify } from "qs";
import { PrintParams } from "@/types/print";
import moment from "moment-mini";
import { visitSave } from '@/api/dataObservation'
import { sessionSetItem, sessionGetItem } from '@/utils/baseFn'
@Component({
  name: "download",
  components: {
    moduleHeader,
  },
})
export default class extends Vue {
  isLoading = false;
  selectList = [];
  list: Array<any> = [];
  created() {
    this.initFetch();
  }

  get filterList() {
    if (UserModule.investRoute.length > 0) {
      const arr = cloneDeep(this.list);
      for (let i = arr.length - 1; i >= 0; i--) {
        if (
          arr[i].offType &&
          UserModule.investRoute.includes(arr[i].offType as string)
        ) {
          arr.splice(i, 1);
        }
      }
      return arr;
    }
    return this.list;
  }

  async initFetch() {
    const res = await fetchExportStatus({
      customerId: CommonMudule.customerId,
    });
    if (res.success && res.statusCode === 0) {
      const preList = [
        {
          key: "family",
          name: "财富体检",
          disabled: res.data.financialAnalysis,
          offType: "assetAnalysis",
        },
        {
          key: "invest",
          name: "投资规划",
          disabled: res.data.investmentPlan,
          offType: "invest",
        },
        {
          key: "base",
          name: "保障规划",
          disabled: res.data.family,
          offType: "base",
        },
        {
          key: "child",
          name: "教育规划",
          disabled: res.data.childrenEdu,
          offType: "childEdu",
        },
        {
          key: "pension",
          name: "退休规划",
          disabled: res.data.pension,
          offType: "pension",
        },
      ];
      const list: any = [];
      for (let i = 0; i < preList.length; i++) {
        if (UserModule.investRoute && UserModule.investRoute.length) {
          UserModule.investRoute.forEach((item) => {
            if (
              item.meta &&
              item.meta.title &&
              item.meta.title === preList[i].name
            ) {
              list.push(preList[i]);
            }
          });
        }
      }
      this.list = list;
    }
  }

  preview() {
     if (this.selectList.length === 0) {
      this.$message.error("至少选择一项");
      return;
    }
      let url = "/preview?keys=" + this.selectList.join(",");
    if(process.env.NODE_ENV !== 'development') {
        url = "/amc/preview?keys=" + this.selectList.join(",");
    }


    window.open(url, "_blank");
  }

  formatUrl() {
    let url = "/print?keys=" + this.selectList.join(",");
    if (process.env.NODE_ENV === "production") {
      url = "/amc" + url;
    }
    return url;
  }

  async submit() {
    if (this.selectList.length === 0) {
      this.$message.error("至少选择一项");
      return;
    }
    try {
      const from = {
      moduleCode: this.$route.meta.code,
      trackId: sessionGetItem('trackId')
    }
    const res = await visitSave(from)
    if (res?.data) {
      sessionSetItem('trackId', res.data.trackId)
    }
    } catch (error) {

    }
    this.isLoading = true;
    let url = this.formatUrl();
    const userData = JSON.parse(
      window.sessionStorage.getItem("userData") as string
    );
    const detailRet = await fetchUserDetail({
      userId: userData.id,
    });
    if (detailRet.statusCode === 0 && detailRet.data) {
      this.$notify.success({
        title: "提交成功",
        message: "报告提交成功，正在下载文件，请稍等...",
        type: "success",
        duration: 5000,
      });
      // let downLoadLink = window.location.origin + url;
      const originUrl =
        process.env.NODE_ENV === "production"
          ? window.location.origin
          : "https://wm-test310.newtamp.cn/amc";
      let downLoadLink = originUrl + url;
      const downloadFileName = `${
        CommonMudule.customerName
      }的专属报告~${moment().format("YYYY-MM-DD~HH:mm:ss")}.pdf`;
      console.log("downloadFileName", downloadFileName);
      let params: PrintParams = {
        token: UserModule.token as string,
        customerId: CommonMudule.customerId,
        isDownLoadPage: true,
        userId: UserModule.userInfo.id,
        customerName: CommonMudule.customerName,
        tenantId: UserModule.tenantId,
        downloadFileName,
        gender: CommonMudule.customerInfo.gender as number,
      };

      let downloadUrl = `${downLoadLink}&${stringify(params)}`;
      console.log("downloadUrl", downloadUrl);
      try {
        const res = await downLoadPdf(downloadUrl);
        console.log("res11", res);
        if (res.data) {
          this.$notify.success({
            title: "下载成功",
            message: downloadFileName + "下载成功",
            duration: 6000,
          });
          this.downloadPdf(res.data, downloadFileName);
        } else {
          this.$notify.error({
            title: "下载失败",
            message: downloadFileName + "下载失败",
            duration: 6000,
          });
        }
      } catch (e) {
        console.log("download res", e);
        this.$notify.error({
          title: "下载失败",
          message: "下载失败" + e,
          duration: 6000,
        });
        this.isLoading = false;
      }
    }
    this.isLoading = false;
  }

  downloadPdf(blobData: Blob, downloadFileName: string) {
    let link = document.createElement("a");
    let url = window.URL.createObjectURL(
      new Blob([blobData], { type: "application/pdf,charset=utf-8" })
    );
    link.style.display = "none";
    link.href = url;
    link.setAttribute("download", downloadFileName);
    document.body.appendChild(link);
    link.click();
  }
}
